import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { styled } from "@mui/material/styles";
import TablePagination from "@mui/material/TablePagination";
import { ConvertEpochToDate } from '@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date';
import { useTranslation } from 'react-i18next';
import PaymentPrint from '../../PaymentSlipEmp/PaymentSlip';
import DialogContentModal from '../../../../../../templates/ApplicationDetails/components/DialogContent';


const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    tableRow: {
        backgroundColor: '#1F4A7C',
        color: '#fff'
    },
    tableCell: {
        backgroundColor: '#f2f2f2',
        padding: '10px',
        fontWeight: 'bold',
        border: '1px solid #ddd',
    },
    blueText: {
        color: '#1F4A7C',
    },
});


const headerData = [
    { slno: "Sl. No" },
    { Name: "Name" },
    // { email: "Email" },
    { mobileNo: "Mobile No" },
    { formType: "Application Type" },
    { plotArea: "Plot Area" },
    { RefNo: "Application No." },
    { Date: "Date" },
    { status: "Status" },
    { district: 'District' },
    { area: 'Area' },
    { nameOfArea: 'Name Of Area' },
    { subArea: 'Sub Area' },
    { paymentStatus: 'Payment Status' },

    // { document: "Documents" },
];
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#1f4a7c",
        color: theme.palette.common.white,
        fontSize: 16
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));
const InboxTable = ({ apiData }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = React.useState(0);
    const [showPaymentDetails, setShowPaymentDetails] = useState(false);
    const [selectedApplicationNo, setSelectedApplicationNo] = useState('');

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    return (
        <Paper sx={{ overflow: "hidden", marginY: 2 }}>
            <TableContainer>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow className={classes.tableRow}>
                            {headerData.map((item) => (
                                <TableCell key={Object.values(item)[0]}>
                                    {Object.values(item)[0]}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ backgroundColor: '#fbfaff' }}>
                        {apiData && apiData?.SelfCertificationDetails
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => (
                                <StyledTableRow key={row.id}>
                                    <StyledTableCell>{index + 1 + page * rowsPerPage}</StyledTableCell>
                                    <StyledTableCell>{row?.name?.[0]?.name}</StyledTableCell>
                                    <StyledTableCell>{row?.name?.[0]?.mobileNumber}</StyledTableCell>
                                    <StyledTableCell>{row?.servicetype}</StyledTableCell>
                                    <StyledTableCell>{row?.totalplotarea}</StyledTableCell>
                                    <StyledTableCell>{row?.applicationnumber}</StyledTableCell>
                                    <StyledTableCell>{ConvertEpochToDate(Number(row?.createdtime))}</StyledTableCell>
                                    <StyledTableCell>{t(row?.status)}</StyledTableCell>
                                    <StyledTableCell>{row?.additionaldetails?.landAreaDetails?.city}</StyledTableCell>
                                    <StyledTableCell>{row?.applicationnumber?.includes('UD') ? row?.additionaldetails?.landAreaDetails?.city : row?.additionaldetails?.landAreaDetails?.locality?.name}</StyledTableCell>
                                    <StyledTableCell>{row?.applicationnumber?.includes('UD') ? row?.additionaldetails?.landAreaDetails?.locality?.name : row?.additionaldetails?.landAreaDetails?.areaType}</StyledTableCell>
                                    <StyledTableCell>{row?.additionaldetails?.landAreaDetails?.village?.name}</StyledTableCell>
                                    <StyledTableCell>
                                        {row?.paymentStatus === "SUCCESS" && row?.servicetype === "FORM_12" ? (
                                            <button
                                                className="btn btn-primary"
                                                style={{ padding: "5px", backgroundColor: "#1F4A7C" }}
                                                onClick={() => {
                                                    setShowPaymentDetails(true);
                                                    setSelectedApplicationNo(row?.applicationnumber);
                                                }}
                                            >
                                                Receipt
                                            </button>
                                        ) : (
                                            <h4>Not Done</h4>
                                        )}
                                        {showPaymentDetails && selectedApplicationNo === row?.applicationnumber && (
                                            <StyledTableCell colSpan={5}>
                                                <DialogContentModal
                                                    title={"Application Payment Details"}
                                                    dataOpen={showPaymentDetails}
                                                    onClose={() => setShowPaymentDetails(false)}
                                                >
                                                    <PaymentPrint id={selectedApplicationNo} />
                                                </DialogContentModal>
                                            </StyledTableCell>
                                        )}
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                    </TableBody>

                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 50, 75, 100]}
                component="div"
                count={apiData?.SelfCertificationDetails?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
};

export default InboxTable;
